class Testimony {
    constructor() {
        this.addListeners()
    }

    addListeners() {
        const slider = document.getElementById('testimonySlider')

        if (slider) {
            const controls = slider.querySelectorAll('.testimony-control')
  
            controls.forEach(control => {
                control.addEventListener('click', (e) => {
                    
                    this.switchSlide(slider, controls, e.target.dataset.id)
                })
            })
        }
    }

    switchSlide(slider, controls, id) {
       
        const slides = slider.querySelectorAll('.testimony-item')

        slides.forEach(slide => {
            if (slide.dataset.id == id) {
                slide.classList.remove('testimony-item--hidden')
            } else {
                slide.classList.add('testimony-item--hidden')
            }
        })
        controls.forEach(control => {
            if (control.dataset.id == id) {
                control.classList.add('testimony-control--active')
            } else {
                control.classList.remove('testimony-control--active')
            }
        })
    }
}

export default Testimony;